import React, { useEffect, useMemo, useState } from "react";
import { Tabs, TabsProps } from "antd";
import { SettingOutlined } from "@ant-design/icons";

import OwnedCar from "./InfoCar/OwnedCar";
import UsedCar from "./InfoCar/UsedCar";
import InterestedCar from "./InfoCar/InterestedCar";

import ContactInformation from "./ServiceRecords/ContactInformation";
import WarrantyInformation from "./ServiceRecords/WarrantyInformation";
import MaintenanceHistory from "./ServiceRecords/MaintenanceHistory";
import ContactHistory from "./ServiceRecords/ContactHistory";
import ContactHistoryV2 from "./ServiceRecords/ContactHistoryV2";
import VehicleInformationyTabs from "./VehicleInformationyTabs";

const VehicleInformation = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const [isSettingShow, setSettingShow] = useState(false);
  const [activeInfoTab, setActiveInfoTab] = useState("1");
  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState("1");

  const itemInfoCarTabs: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe sở hữu ({stData.xesohuu?.length || 0})
        </span>
      ),
      children: <OwnedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} />,
    },
    {
      key: "2",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe sử dụng ({stData.xesudung?.length || 0})
        </span>
      ),
      children: <UsedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} />,
    },
    {
      key: "3",
      label: (
        <span className="custom-page-css font-light text-lg">
          Xe quan tâm ({stData.xequantam0?.length || 0})
        </span>
      ),
      children: <InterestedCar stData={stData} stChange={(data) => {
        stChange(data)
      }} />,
    },
  ];

  type TabItem = NonNullable<TabsProps["items"]>[number];

  const contractInfoTab: TabItem = {
    key: "1",
    label: (
      <span className="custom-page-css font-light text-lg">
        Thông tin hợp đồng
      </span>
    ),
    children: (
      <ContactInformation
        stData={stData}
      />
    ),
  };

  const warrantyInfoTab: TabItem = {
    key: "2",
    label: (
      <span className="custom-page-css font-light text-lg">
        Thông tin bảo hành
      </span>
    ),
    children: (
      <WarrantyInformation
        stData={stData}
      />
    ),
  };

  const maintenanceHistoryTab: TabItem = {
    key: "3",
    label: (
      <span className="custom-page-css font-light text-lg">
        Lịch sử bảo trì bảo dưỡng
      </span>
    ),
    children: (
      <MaintenanceHistory
        stData={stData}
      />
    ),
  };
  const interestedCarTabs: TabItem = {
    key: "4",
    label: (
      <span className="custom-page-css font-light text-lg">
        Lịch sử tiếp xúc
      </span>
    ),
    children: (
      activeInfoTab === '3' ? <ContactHistory stData={stData} /> : <ContactHistoryV2 stData={stData} />
    ),
  };

  const vehicleInfoTab: TabItem = {
    key: "5",
    label: (
      <span className="custom-page-css font-light text-lg">Thông tin xe</span>
    ),
    children: (
      <VehicleInformationyTabs stData={stData} />
    ),
  };

  const bottomTabs = useMemo<TabsProps["items"]>(() => {
    switch (activeInfoTab) {
      case "1":
        return [
          contractInfoTab,
          warrantyInfoTab,
          maintenanceHistoryTab,
          interestedCarTabs,
        ];
      case "2":
        return [vehicleInfoTab];
      default:
        return [interestedCarTabs];
    }
  }, [activeInfoTab, contractInfoTab, warrantyInfoTab, maintenanceHistoryTab, interestedCarTabs, vehicleInfoTab]);

  useEffect(() => {
    if (bottomTabs && bottomTabs.length > 0) {
      setActiveServiceRecordsTab(bottomTabs[0].key as string);
    }

  }, [activeInfoTab]);

  return (
    <>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css"
        style={{ width: "100%" }}
      >
        <Tabs
          activeKey={activeInfoTab}
          items={itemInfoCarTabs}
          onChange={(key) => setActiveInfoTab(key)}
        />
      </div>

      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%", marginTop: "16px" }}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={bottomTabs}
          onChange={(k) => setActiveServiceRecordsTab(k)}
        />
      </div>
    </>
  );
};

export default VehicleInformation;
